// Import core lib dependencies.
import React from 'react';
import PropTypes from 'prop-types';

// Import child components.
import ProgressBarSegment from './ProgressBarSegment.jsx';

// Misc dependencices.
import { capitalize } from '../../../../common/utils/string.js';

// Model objects.
import { Entity } from '../../model.js';

/**
 * <pre>
 * Goal -> ProgressBar module React class.
 *
 * This component outputs markup to render a Progress Bar within the Goal component.
 * </pre>
 *
 * @author Tim Loram
 *
 * @docPreview {namedExport: "docPreviewExport"}
 *
 * @memberof module:Goal.Components.Elements
 * @namespace
 *
 * @return {module:Goal.Components.Elements.ProgressBar}
 */
class ProgressBar extends React.Component {
  /**
   * Constructor.
   *
   * @param {object} props The injected props
   */
  constructor(props) {
    super(props);
  }

  /**
   * Render
   *
   * @return {module:Goal.Components.Elements.ProgressBar}
   */
  render() {
    // Generate segments.
    const _segments = [];
    for (const segmentKey in this.props.segments) {
      // Grab the Segment definition.
      const segmentDef = this.props.segments[segmentKey];

      _segments.push(
        <ProgressBarSegment
          {...segmentDef}
          orientation={this.props.orientation}
          segmentSize={this.props.segmentSize}
          formatting={this.props.formatting}
        />
      );
    }

    // Define classes.
    const _wrapperClasses = 'xProgressBarWrapper xOrientation' + capitalize(this.props.orientation);

    return <div className={_wrapperClasses}>{_segments}</div>;
  }
}

/**
 * React PropTypes.
 *
 * @type {Object}
 * @property {Number} metricId The metric id
 * @property {Array} segments Array containing the segment definition objects.
 * @property {String} orientation The progress bar orientation.
 * @property {module:Goal.Model.Entity.Formatting} formatting Object defining a various formatting options (eg. no of decimal places to show progress percentages).
 */
ProgressBar.propTypes = {
  metricId:    PropTypes.number,
  segments:    PropTypes.array,
  orientation: PropTypes.string,
  formatting:  PropTypes.instanceOf(Entity.Formatting),
};

// Export the dumb component.
export default ProgressBar;
